import { render, staticRenderFns } from "./SalesInvoiceMailModalContent.vue?vue&type=template&id=bedfe2d0"
import script from "./SalesInvoiceMailModalContent.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceMailModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports